import { Injectable } from '@angular/core';
import { TicketReservationPlugin } from 'projects/qcloud-models/reservation-plugin/ticket-reservation-plugin';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TicketReservationService {

  ticketReservation: Observable<TicketReservationPlugin>;
  private ticketReservationSubject: Subject<TicketReservationPlugin>;

  constructor() {
    this.ticketReservationSubject = new Subject<TicketReservationPlugin>();
    this.ticketReservation = this.ticketReservationSubject.asObservable();
  }

  updateTicketReservation(ticketReservation: TicketReservationPlugin) {
    this.ticketReservationSubject.next(ticketReservation);
  }
}
